
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useLanguage } from '@/context/language-context';

interface ProfileDetailSkeletonProps {
  onBack: () => void;
}

const ProfileDetailSkeleton: React.FC<ProfileDetailSkeletonProps> = ({ onBack }) => {
  const { t } = useLanguage();
  
  return (
    <div className="py-8 px-4 max-w-4xl mx-auto">
      <div className="flex items-center mb-6">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={onBack} 
          className="mr-2"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t('profile.back')}
        </Button>
      </div>
      
      <Skeleton className="h-[300px] w-full mb-6 rounded-lg" />
      <Skeleton className="h-8 w-64 mb-2" />
      <Skeleton className="h-4 w-48 mb-6" />
      
      <div className="grid grid-cols-1 gap-6">
        <Skeleton className="h-[100px] rounded-lg" />
        <Skeleton className="h-[400px] rounded-lg" />
        <Skeleton className="h-[200px] rounded-lg" />
      </div>
    </div>
  );
};

export default ProfileDetailSkeleton;
